import { createTheme } from '@mui/material';

const COLORS = {
  primary: '#2C2B2A',
  secondary: '#C2B59B',
  light: '#F0EAD8',
  dark: '#61ce70',
  grayBg: '#F0EAD8',
  contrastText: '',
};

export const theme = createTheme({
  colors: COLORS,
  direction: 'rtl',
  typography: {
    fontFamily: 'Nunito Sans, Noto Naskh Arabic',
    allVariants: {
      // color: '#273353',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 'bold',
        },
        text: {
          color: COLORS?.primary,
          '&:hover': {
            color: COLORS.secondary,
          },
        },
        contained: {
          backgroundColor: COLORS.primary,
          color: 'white',
        },
        outlined: {
          color: COLORS.primary,
          borderColor: COLORS.primary,
          '&:hover': {
            backgroundColor: COLORS.primary,
            color: 'white',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: COLORS.primary,
            },
            '&:hover fieldset': {
              borderColor: COLORS.primary,
            },
            '&.Mui-focused fieldset': {
              borderColor: COLORS.primary,
            },
          },
          '& .MuiInputLabel-root': {
            color: '#273353',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: COLORS.secondary,
          },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          '& .MuiBox-root': {
            '&[dir="rtl"]': {
              '& .MuiButton-root': {
                '& .MuiButton-startIcon': {
                  marginRight: 0,
                  marginLeft: -4,
                },
                '& .MuiButton-endIcon': {
                  marginLeft: 0,
                  marginRight: -4,
                },
              },
              '& .MuiInputBase-root': {
                '& .MuiInputAdornment-root': {
                  '& .MuiInputAdornment-positionStart': {
                    marginRight: 0,
                    marginLeft: 8,
                  },
                  '& .MuiInputAdornment-positionEnd': {
                    marginLeft: 0,
                    marginRight: 8,
                  },
                },
              },
              '& .MuiFormControl-root': {
                '& .MuiInputLabel-root': {
                  right: 0,
                  left: 'auto',
                  transformOrigin: 'right',
                },
                '& .MuiInputBase-input': {
                  textAlign: 'right',
                },
              },
            },
          },
        },
      },
    },
  },
});
